import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";

import { useTranslation } from "react-i18next";

import { USER_INFO_ERROR_KEYS, USER_INFO_LENGTHS } from "../types";

export const useEmailValidation = (email: string) => {
  const { t } = useTranslation();

  const [emailErrorKey, setEmailErrorKey] = useState<string | null>(null);
  const [emailErrorParams, setEmailErrorParams] = useState({});

  const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{1,10}$/;

  const emailIsValid = regexEmail.test(email) && !emailErrorKey;

  const validateEmail = (e: any) => {
    const inputValue = e.target.value;

    if (inputValue && !regexEmail.test(inputValue)) {
      setEmailErrorKey(USER_INFO_ERROR_KEYS.InvalidEmailFormat);
      setEmailErrorParams({});
    }

    if (inputValue && inputValue.length > USER_INFO_LENGTHS.Email) {
      setEmailErrorKey(USER_INFO_ERROR_KEYS.FieldLengthNotValid);
      setEmailErrorParams({
        maxNumber: USER_INFO_LENGTHS.Email
      });
    }
  };

  const clearEmailError = () => {
    setEmailErrorKey(null);
    setEmailErrorParams({});
  };

  const handleEmailInputChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    setValue: Dispatch<SetStateAction<string>>
  ) => {
    const emailValue = event.target.value;

    event.preventDefault();
    setValue(emailValue);
    validateEmail(event);

    if (emailValue.length <= USER_INFO_LENGTHS.Email) {
      clearEmailError();
    }
  };

  return {
    emailIsValid,
    emailError: emailErrorKey ? t(emailErrorKey, emailErrorParams) : null,
    setEmailErrorKey,
    clearEmailError,
    validateEmail,
    handleEmailInputChange
  };
};
